export enum CustomerSiteBillingPerson {
  structure = 'STRUCTURE',
  laveo = 'LAVEO',
}
